import React from "react";
import { FaGraduationCap, FaGithub, FaHeart, FaCode } from "react-icons/fa";

export const AboutUs: React.FC = () => {
    return (
        <div className="generator" style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }}>
            <div className="generator-header" style={{ textAlign: 'center', marginBottom: '40px' }}>
                <h1 className="generator-title" style={{ fontSize: '2.5rem' }}>About ScoreSmart</h1>
                <p className="generator-subtitle">Student-Led Open Source UPSC Revision Ecosystem</p>
            </div>

            <div className="input-section" style={{ lineHeight: '1.8', color: '#334155' }}>
                <p style={{ fontSize: '1.1rem', marginBottom: '24px' }}>
                    Welcome to <strong>ScoreSmart</strong>, a suite of high-performance tools designed specifically for
                    <strong> UPSC revision</strong>, <strong>IAS preparation</strong>, and <strong>competitive examination mastery</strong>.
                </p>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px', margin: '40px 0' }}>
                    <div style={{ background: 'white', padding: '24px', borderRadius: '16px', border: '1px solid #e2e8f0' }}>
                        <FaGraduationCap size={32} color="#e11d48" style={{ marginBottom: '16px' }} />
                        <h3 style={{ marginBottom: '10px' }}>Our Mission</h3>
                        <p style={{ fontSize: '0.9rem' }}>
                            To provide aspirants with the world's most advanced <strong>UPSC notes</strong> management and
                            <strong> spaced repetition</strong> tools—completely free and open source.
                        </p>
                    </div>
                    <div style={{ background: 'white', padding: '24px', borderRadius: '16px', border: '1px solid #e2e8f0' }}>
                        <FaCode size={32} color="#2563eb" style={{ marginBottom: '16px' }} />
                        <h3 style={{ marginBottom: '10px' }}>Built by Students</h3>
                        <p style={{ fontSize: '0.9rem' }}>
                            Crafted by a collective of students and developers who understand the struggle of managing
                            vast syllabi for <strong>civil services examinations</strong>.
                        </p>
                    </div>
                </div>

                <div className="section-header">
                    <h2>Mission & Open Access</h2>
                </div>
                <p style={{ fontSize: '0.95rem' }}>
                    ScoreSmart is built for <strong>UPSC revision</strong>, <strong>IAS mains answer writing</strong>,
                    and <strong>prelims fact memorization</strong>. Our platform utilizes advanced tools to help you build
                    <strong> precise UPSC study material</strong> directly from your raw notes.
                </p>

                <div style={{ marginTop: '40px', padding: '24px', background: '#f8fafc', borderRadius: '16px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '20px' }}>
                        <FaHeart color="#e11d48" />
                        <FaGithub color="#1e293b" />
                    </div>
                    <p style={{ fontWeight: '600' }}>Supporting the Open Source Community</p>
                    <p style={{ fontSize: '0.85rem', color: '#64748b' }}>
                        ScoreSmart is a non-profit initiative. If you find these tools helpful for your
                        <strong> UPSC preparation</strong>, consider sharing them with your fellow aspirants.
                    </p>
                </div>
            </div>
        </div>
    );
};
